import React from 'react';
/**
 * DropdownContext
 * {
 *  toggle: PropTypes.func.isRequired,
 *  isOpen: PropTypes.bool.isRequired,
 *  direction: PropTypes.oneOf(['up', 'down', 'left', 'right']).isRequired,
 *  inNavbar: PropTypes.bool.isRequired,
 *  disabled: PropTypes.bool
 * }
 */

export var DropdownContext = React.createContext({});


//////////////////
// WEBPACK FOOTER
// ./node_modules/reactstrap/es/DropdownContext.js
// module id = 144
// module chunks = 0